export default class Config {
  static DEFAULT_FONT = 'Arial'
}
